import { selectBalancingConstants } from "../balancingSelectors/selectBalancingConstants";
import { IdEvent } from "../constants/IdEvents";
import { utilTime } from "../utils/utilTime";
import { selectEventInfoByTypeId, selectEventRewards, selectIsEventRunning } from "./selectEventInfo";
export var selectPurchasePointsEventInfo = function (state) {
    return selectEventInfoByTypeId(state, IdEvent.PurchasePoints);
};
export var selectPurchasePointsEventRewards = function (state) {
    var eventInfo = selectPurchasePointsEventInfo(state);
    var eventDetails = selectPurchasePointsEventDetails(state);
    if (eventInfo && eventInfo.balancing) {
        var difficultyLevel = eventInfo.balancing.difficultyLevel;
        if (difficultyLevel &&
            difficultyLevel[0] &&
            eventDetails &&
            eventDetails[0] &&
            eventDetails[0].rewardId) {
            return selectEventRewards(state, difficultyLevel[0], eventDetails[0].rewardId);
        }
    }
    return;
};
export var selectPurchasePointsEventDetails = function (state) {
    var purchasePointsEvent = state.eventInfo.purchasePointsEvent;
    return purchasePointsEvent;
};
export var selectPurchasePointsEventAmount = function (state) {
    return state.purchasePointsEventInfo.purchasePoints;
};
export var selectPurchasePointEventRemainingTime = function (state) {
    var purchasePointsDetails = selectPurchasePointsEventDetails(state);
    var purchasePointsEventBufferTime = selectBalancingConstants().purchasePointsEventBufferTime;
    if (purchasePointsDetails && purchasePointsDetails[0]) {
        var startTime = purchasePointsDetails[0].startTime || 0;
        var duration = purchasePointsDetails[0].duration || 0;
        var endTime = startTime + utilTime.secondsToMs(duration);
        var bufferTime = utilTime.secondsToMs(purchasePointsEventBufferTime);
        // Show time subtracting buffer time from actual duration
        return endTime - bufferTime;
    }
    return 0;
};
export var selectIsPurchasePointsEventRunning = function (state) {
    var eventInfo = selectPurchasePointsEventInfo(state);
    if (eventInfo) {
        var isPurchasePointsEventRunning = selectIsEventRunning(eventInfo.proto);
        return (isPurchasePointsEventRunning &&
            state.purchasePointsEventInfo.showPurchasePointsHudButton);
    }
    return false;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectPurchasePointsEventInfo.ts
// module id = 299
// module chunks = 3